import isDuitangImage from './isDuitangImage';
import { _dtImageTrans } from './__inner/image/_dtImageTrans';
import { _transToWebp } from './__inner/image/_transToWebp';

/**
 * @description 缩放成指定宽度、高度自适应的图片 默认保留gif动图 其他类型如png、jpeg等加webp格式
 * @param url 图片地址
 * @param width 指定的宽度
 * @returns 处理后的图片地址
 */
const dtImageThumbOnlyNoWebpForGif = (url: string, width: number): string => {
  let ret = _dtImageTrans(url, true, width, false);
  if (isDuitangImage(ret)) {
    ret = _transToWebp(ret);
    ret = ret.replace(/gif_webp/, 'gif');
  }
  return ret;
};

export default dtImageThumbOnlyNoWebpForGif;
